import { Divider, Flex, PaperSection } from '@shared/components';

import AttachDocumentReadonlyFields, {
  type AttachDocumentReadonlyFieldsProps,
} from './attach-document-readonly-fields';
import CertificateSettingsReadonlyFields, {
  type CertificateSettingsReadonlyFieldsProps,
} from './certificate-settings-readonly-fields';
import DurationSettingsReadonlyFields, {
  type DurationSettingsReadonlyFieldsProps,
} from './duration-settings-readonly-fields';
import QuestionnaireSettingsReadonlyFields, {
  type QuestionnaireSettingsReadonlyFieldsProps,
} from './questionnaire-settings-readonly-fields';
import ResultDisplaySettingsReadonlyFields, {
  type ResultDisplaySettingsReadonlyFieldsProps,
} from './result-display-settings-readonly-fields';

export interface ExamCourseSettingsReadonlyFieldsProps {
  visibleFields: {
    singleSessionDuration: boolean;
    multipleSessionDuration: boolean;
    condition: boolean;
    averageScoreCondition: boolean;
    attachDocument: boolean;
  };
  values: {
    certificate: CertificateSettingsReadonlyFieldsProps['values'];
    examDuration: DurationSettingsReadonlyFieldsProps['values'];
    questionnaire: QuestionnaireSettingsReadonlyFieldsProps['values'];
    resultDisplay: ResultDisplaySettingsReadonlyFieldsProps['values'];
    attachDocument: AttachDocumentReadonlyFieldsProps['values'];
  };
}

export default function ExamCourseSettingsReadonlyFields(
  props: Readonly<ExamCourseSettingsReadonlyFieldsProps>,
) {
  const { visibleFields, values } = props;

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(6) }}>
      <PaperSection title='Pre-Exam Settings'>
        <Flex
          sx={(theme) => ({
            p: theme.spacing(6),
            flexDirection: 'column',
            gap: theme.spacing(6),
          })}
        >
          <DurationSettingsReadonlyFields
            visibleFields={visibleFields}
            values={values.examDuration}
          />
        </Flex>
      </PaperSection>
      <PaperSection title='During & Post-Exam Settings'>
        <Flex
          sx={(theme) => ({
            p: theme.spacing(6),
            flexDirection: 'column',
            gap: theme.spacing(6),
          })}
        >
          <ResultDisplaySettingsReadonlyFields values={values.resultDisplay} />
          <Divider />
          <CertificateSettingsReadonlyFields
            visibleFields={visibleFields}
            values={values.certificate}
          />
          <Divider />
          <QuestionnaireSettingsReadonlyFields values={values.questionnaire} />
          <Divider />
          <AttachDocumentReadonlyFields
            visibleFields={visibleFields}
            values={values.attachDocument}
          />
        </Flex>
      </PaperSection>
    </Flex>
  );
}
